import React from "react";
import { useCompanyModel } from "../companyModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";


export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        categoryOption
    } = useCompanyModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "标题",
            fieldName: "title"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "业务范围",
            fieldName: "columnCode",
            options: categoryOption
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "创建人",
            fieldName: "createUser"
        },
    ]

    return (
        <YhPageHeader
            title="公司荣誉"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => loadData(initPgCfg, { ...searchParam, ...params })}
            handleReset={resetSearchParam}
        />
    );
}